import { readBrandInUrl } from './readBrandInUrl';
import { CdkBrand, RealmCode, RealmDomain, RealmName } from '../app/types/enum';

const BRANDS = {
  rogers: {
    code: RealmCode.rogers,
    name: RealmName.rogers,
    domain: RealmDomain.rogers,
    cdkBrand: CdkBrand.rogers,
    chatAdminBrand: RealmName.rogers,
    dialogApi: '/va/dialog',
    applicationName: 'anna',
  },
  fido: {
    code: RealmCode.fido,
    name: RealmName.fido,
    domain: RealmDomain.fido,
    cdkBrand: CdkBrand.fido,
    chatAdminBrand: RealmName.fido,
    dialogApi: '/va/dialog',
    applicationName: 'jack',
  },
  shaw: {
    code: RealmCode.shaw,
    name: RealmName.shaw,
    domain: RealmDomain.shaw,
    cdkBrand: CdkBrand.rogers,
    chatAdminBrand: RealmName.shaw,
    dialogApi: '/va-orchestrator/dialogue',
    applicationName: 'anna',
  },
  r4b: {
    code: RealmCode.rogers,
    name: RealmName.rogers,
    domain: RealmDomain.rogers,
    cdkBrand: CdkBrand.rogers,
    chatAdminBrand: RealmName.r4b,
    dialogApi: '/va/dialog',
    applicationName: 'anna',
  },
  shawDirect: {
    code: RealmCode.shaw,
    name: RealmName.shaw,
    domain: RealmDomain.shaw,
    cdkBrand: CdkBrand.rogers,
    chatAdminBrand: RealmName.shawDirect,
    dialogApi: '/va-orchestrator/dialogue',
    applicationName: 'anna',
  },
};

export function getBrand() {
  const brand =
    localStorage.getItem('ucx-host-app-brand') ||
    window.parent['ucxBrand'] ||
    readBrandInUrl();
  return BRANDS[brand];
}
